<div class="general-legend">
  <div class="general-legend__item">
    <div class="general-legend__title general-legend__title--green">{{ legend.high.title }}</div>
<!--    <span class="general-legend__color general-legend__color--green">Зеленая зона - </span>-->
    <span class="general-legend__description">{{ legend.high.description }}</span>
  </div>
  <div class="general-legend__item">
    <div class="general-legend__title general-legend__title--yellow">{{ legend.middle.title }}</div>
<!--    <span class="general-legend__color general-legend__color--yellow">Желтая зона - </span>-->
    <span class="general-legend__description">{{ legend.middle.description }}</span>
  </div>
  <div class="general-legend__item">
    <div class="general-legend__title general-legend__title--red">{{ legend.low.title }}</div>
<!--    <span class="general-legend__color general-legend__color--red">Красная зона - </span>-->
    <span class="general-legend__description">{{ legend.low.description }}</span>
  </div>
</div>
